import React, { useState } from 'react';
import { Container, Row, Col, Alert, Spinner } from 'react-bootstrap';
import Header from '../components/Header/Header';
import SearchForm from '../components/SearchForm/SearchForm';
import Results from '../components/Results/Results';

import userAPI from '../context/Api';
import './AnalysisPage.css';

const AnalysisPage = () => {
  const [formData, setFormData] = useState({
    keyword: '',
    country: '2356',    // India
    language: '1000',   // English
    date: new Date().toISOString().split('T')[0],
  });

  const [results, setResults] = useState([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);
  const [targetedKeywords, setTargetedKeywords] = useState([]);

  const locationNames = {
    '2356': 'India',
    '2840': 'United States',
    '2826': 'United Kingdom',
    '2036': 'Australia',
  };

  const languageNames = {
    '1000': 'English',
  };

  const normalizeKeywords = (keywordText) => {
    return keywordText
      .replace(/\r/g, '')
      .split(/[\n,]+/)
      .map((kw) => kw.trim())
      .filter(Boolean)
      .map((kw) => kw.toLowerCase());
  };

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({ ...prev, [name]: value }));
  };

  const handleSubmit = async (event) => {
    event?.preventDefault();
    setLoading(true);
    setError(null);
    setResults([]);

    const keywordTexts = normalizeKeywords(formData.keyword);

    if (keywordTexts.length === 0) {
      setLoading(false);
      setError('Please add at least one keyword.');
      return;
    }

    const payload = {
      keyword_texts: keywordTexts,
      date: formData.date,
      language_id: formData.language.toLowerCase(),
      location_id: formData.country.toLowerCase(),
    };

    setTargetedKeywords(keywordTexts);

    userAPI.keyword(payload)
      .then((response) => {
        const data = response.data;

        if (!data.success) throw new Error(data.error || 'Error occurred from backend');

        setResults(
          data.result_process_dataframe.map((item) => ({
            keyword: item.keyword || 'N/A',
            avgMonthlySearches: Number(item.avgMonthlySearches) || 0,
            competition: item.competition || 'N/A',
            ...Object.fromEntries(
              item.monthly_search_volumes.map(({ month, searches }) => [month, searches])
            ),
          }))
        );
      })
      .catch((error) => {
        setError(error.response?.data?.message || error.message);
      })
      .finally(() => {
        setLoading(false);
      });
  };

  return (
    <div className="analysis-page">
      <Header />
      <Container className="dashboard-shell">
        <div className="dashboard-grid">
          <div className="dashboard-left">
            <SearchForm formData={formData} handleInputChange={handleInputChange} handleSubmit={handleSubmit} />
          </div>

          <div className="dashboard-right">
            <div className={`dashboard-main ${loading ? 'loading-state' : ''} ${results.length > 0 ? 'results-active' : 'idle-state'}`}>
              {loading && (
                <div className="loading-panel">
                  <Spinner animation="border" />
                  <p>Crunching keyword data...</p>
                </div>
              )}

              {error && <Alert variant="danger">{error}</Alert>}

              {!loading && !error && results.length > 0 && (
                <Results results={results} TargetedKeywords={targetedKeywords} />
              )}

              {!loading && !error && results.length === 0 && (
                <div className="empty-state-panel">
                  <h4>Ready to search</h4>
                  <p>Enter keywords in the left panel and click Analyze to show results here.</p>
                </div>
              )}
            </div>
          </div>
        </div>
      </Container>
    </div>
  );
};

export default AnalysisPage;
